import React from 'react';
import './error-screen.scss';
import { SVGS } from '@zonofi/zono-money-design-system';
import {
  sendWAEventToParent,
  useAppSelector,
} from '@zonofi/zono-money-helpers';
import { getCustomerInvite, getIsSimulation } from '@zonofi/zono-money-store';
import {
  FallBackScreen,
  onClickBackToWhatsapp,
} from '@zonofi/zono-money-whatsapp-stack';

export const ErrorScreenV2 = (): React.ReactNode => {
  const inviteDetails = useAppSelector(getCustomerInvite);
  const isSimulation = useAppSelector(getIsSimulation);
  const { seller, waConfig } = inviteDetails;

  return (
    <FallBackScreen
      image={SVGS.ErrorScreenImageV2}
      message="Link Expired"
      description="Link is valid for 24 hours only. To get a fresh link, please message us again on WhatsApp."
      buttonName="Back To Whatsapp"
      onButtonClick={() =>
        onClickBackToWhatsapp({
          whatsappPhoneNo: waConfig?.whatsappPhoneNo,
          workspaceId: seller?.workspaceId,
          isSimulation: isSimulation,
          sendEventToParent: () => {
            sendWAEventToParent({ linkExpired: true });
          },
        })
      }
    />
  );
};
